<!--
  Generated template for the PictureViewerPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="white" (click)="dismiss()">
        {{ 'GLOBAL_CANCEL' | translate }}
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end" *ngIf="icon">
      <ion-button fill="clear" color="white" (click)="buttonClick()">
        <ion-icon [name]="icon"></ion-icon>
      </ion-button>
      <ion-button *ngIf="icon1" fill="clear" color="white" (click)="button1Click()">
        <ion-icon [name]="icon1"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content fullscreen>
  <div class="slides-container">


    <swiper-container class="swiper-main" #sliderBig (ionSlideDidChange)="changeBig()" [initialSlide]="activeIndex" zoom="true" parallax="true"
    [controller]="{ control: sliderMini?.swiper }">
    <!-- <ion-slides #sliderBig (ionSlideDidChange)="changeBig()" [initialSlide]="activeIndex" zoom="true" parallax="true"> -->
      <swiper-slide *ngFor="let picture of pictures;index as i">
      <!-- <ion-slide *ngFor="let picture of pictures;index as i"> -->
        <img [src]="picture.imageLink" />
      </swiper-slide><!-- </ion-slide> -->
    <!-- </ion-slides> -->
    </swiper-container>
    <swiper-container 
    #sliderMini
    class="thumbs"
    [slidesPerView]="'auto'"
    [spaceBetween]="10"
    [centeredSlides]="false"
    [freeMode]="true"
    [zoom]="true"
    [parallax]="true"
    [watchSlidesProgress]="true"
    [watchSlidesVisibility]="true"
    [slideToClickedSlide]="true"
  >
        <swiper-slide class="mini-slider" *ngFor="let picture of pictures;index as i" (click)="changeMini(i)">
          <img [src]="picture.imageLink" />
        </swiper-slide>
      </swiper-container>

  </div>
</ion-content>
